// extracted by mini-css-extract-plugin
export default {"heading":"SearchFilter_heading__HVL-L"};